// The notice across the top of Astra after a landing conversation was
// brought into the account (#2945; founder pick A of the 2026-10-02 mocks,
// as a notice, not a choice: the import already happened, with no consent
// step by founder decision). Two actions: Start fresh (the carried thread is
// archived, with an Undo) and dismiss. Same component in /astra and the
// drawer, so the words cannot drift between them.
import React from 'react';
import { ChatBubbleLeftRightIcon, XMarkIcon } from '@heroicons/react/24/outline';

export const CARRY_COPY = {
    brought: (n) => `We brought over your ${n === 1 ? 'question' : `${n} questions`} from before you signed in.`,
    // A carried read (#3480): the school's read, and any questions with it.
    broughtRead: (school, n) => (n
        ? `We brought over your ${school} read and your ${n === 1 ? 'question' : `${n} questions`} from before you signed in.`
        : `We brought over your ${school} read from before you signed in.`),
    startFresh: 'Start fresh',
    setAside: 'Set aside. This is a new conversation.',
    undo: 'Undo',
    dismiss: 'Dismiss',
    busy: 'One moment...',
    failed: "That didn't go through. Please try again in a moment.",
};

export default function CarryBanner({ notice, busy = false, failed = false, onStartFresh, onUndo, onDismiss }) {
    if (!notice || notice.dismissed) return null;
    const archived = Boolean(notice.archived);
    return (
        <div data-testid="carry-banner" role="status"
             className="shrink-0 border-b border-[#CFE0D2] bg-[#F0F7F1] px-4 py-2.5 sm:px-5">
            <div className="flex items-start gap-3">
                <ChatBubbleLeftRightIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#1A4D2E]" aria-hidden="true" />
                <div className="min-w-0 flex-1">
                    <p className="text-sm text-[#1A2E1F]" data-testid="carry-banner-text">
                        {archived ? CARRY_COPY.setAside
                            : notice.read ? CARRY_COPY.broughtRead(notice.read, notice.questions || 0)
                                : CARRY_COPY.brought(notice.questions || 0)}
                    </p>
                    {failed && <p className="mt-0.5 text-[13px] text-[#8A3B12]">{CARRY_COPY.failed}</p>}
                    <div className="mt-1 flex flex-wrap items-center gap-2">
                        {archived ? (
                            <button type="button" onClick={onUndo} disabled={busy} data-testid="carry-undo"
                                    className="min-h-[44px] rounded-xl px-1 text-sm font-semibold text-[#1A4D2E] underline underline-offset-4 disabled:opacity-50">
                                {busy ? CARRY_COPY.busy : CARRY_COPY.undo}
                            </button>
                        ) : (
                            <button type="button" onClick={onStartFresh} disabled={busy} data-testid="carry-start-fresh"
                                    className="min-h-[44px] rounded-xl px-1 text-sm font-semibold text-[#1A4D2E] underline underline-offset-4 disabled:opacity-50">
                                {busy ? CARRY_COPY.busy : CARRY_COPY.startFresh}
                            </button>
                        )}
                    </div>
                </div>
                <button type="button" onClick={onDismiss} aria-label={CARRY_COPY.dismiss} data-testid="carry-dismiss"
                        className="-mr-2 -mt-1 flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-[#4A6B53] hover:bg-[#E0EFE2]">
                    <XMarkIcon className="h-5 w-5" />
                </button>
            </div>
        </div>
    );
}
